import { render, staticRenderFns } from "./Fertilizer.vue?vue&type=template&id=1232c45c"
import script from "./Fertilizer.vue?vue&type=script&lang=js"
export * from "./Fertilizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports